import React, { createContext, useState, useContext, useEffect } from 'react';

export const UserContext = createContext();

export const UserContextProvider = ({ children }) => {

	const [userData, setUserDataState] = useState(null);
	const userLogged = userData !== null;

	const setUserData = (data) => {
		setUserDataState(data);
		if (data?.token) {
			sessionStorage.setItem('authToken', data.token);
		} else {
			sessionStorage.removeItem('authToken');
		}
	};

	const logout = () => setUserData(null);

	useEffect(() => {
		window.addEventListener('logoutUser', logout);
		return () => window.removeEventListener('logoutUser', logout);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<UserContext.Provider value={{ userLogged, userData, setUserData, logout }}>
			{children}
		</UserContext.Provider>
	);
};

export const useUser = () => {
	return useContext(UserContext);
};
